<section class="organization-dialog">
  <header class="dialog-header">
    <h1 class="company-title">{{organization?.Company?.Name}}</h1>

    <mat-menu #appMenu="matMenu">
      <button mat-menu-item type="button" (click)="createUser()"><mat-icon>person_add</mat-icon>Ny administratör</button>
      <button mat-menu-item type="button" (click)="createSalaryReciever()"><mat-icon>person_add</mat-icon>Ny medarbetare</button>
    </mat-menu>
    <div class="header-actions">
      <button *ngIf="isMasterAccount || isAdmin"
              mat-flat-button
              color="accent"
              type="button"
              class="edit-company-action"
              (click)="editCompany(organization)">
        Redigera företagsuppgifter
      </button>
      <button mat-icon-button type="button" class="dialog-actions" [matMenuTriggerFor]="appMenu"
              aria-label="Fler alternativ" matTooltip="Fler alternativ"><mat-icon>more_vert</mat-icon></button>
    </div>
  </header>

  <mat-tab-group (selectedTabChange)="onTabChange($event)" class="custom-tab-group">
    <mat-tab label="Administratörer ({{customerData?.length || 0}})">
      <div class="tab-content">
        <div class="filter-bar">
          <mat-form-field class="search-field" appearance="fill" floatLabel="always" subscriptSizing="dynamic">
            <mat-label>Sök administratör</mat-label>
            <mat-icon matPrefix aria-hidden="true">search</mat-icon>
            <input [disabled]="usersLoading || usersLoadError" matInput #administratorSearch type="search" (input)="applyFilter(administratorSearch.value)">
            <button *ngIf="administratorSearch.value" mat-icon-button matSuffix type="button"
                    (click)="administratorSearch.value = ''; applyFilter(''); administratorSearch.focus()"
                    aria-label="Rensa sökning" matTooltip="Rensa sökning">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <div class="table-shell">
          <div class="table-scroll">
            <div *ngIf="usersLoading" class="table-skeleton" role="status" aria-label="Laddar administratörer">
              <div class="skeleton-row" *ngFor="let row of [1,2,3,4,5]" aria-hidden="true">
                <div *ngFor="let column of displayedColumns" class="skeleton-column" [ngClass]="'mat-column-' + column">
                  <span class="skeleton-cell"></span>
                </div>
              </div>
            </div>
            <div *ngIf="!usersLoading && usersLoadError" class="empty-state" role="alert">Kunde inte läsa administratörer. Försök öppna dialogen igen.</div>
            <mat-table [class.table-loading]="usersLoading || usersLoadError" [dataSource]="dataSource" matSort (matSortChange)="sortData($event)"
                       matSortActive="name" matSortDirection="asc" matSortDisableClear>
              <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Namn</mat-header-cell>
                <mat-cell *matCellDef="let row" (click)="editUser(row)" class="clickable-cell">
                  <strong>{{row?.FirstName + ' ' + row?.LastName | truncate:25}}</strong>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="roles">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxShow="false" fxShow.gt-sm>Roller</mat-header-cell>
                <mat-cell *matCellDef="let row" fxShow="false" fxShow.gt-sm>
                  <span *ngIf="row.OrganizationMasterAccount">Master, {{ getRolesAsString(row?.Roles) }}</span>
                  <span *ngIf="!row.OrganizationMasterAccount">{{ getRolesAsString(row?.Roles) }}</span>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="personalNumber">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxShow="false" fxShow.gt-sm>Personnummer</mat-header-cell>
                <mat-cell *matCellDef="let row" fxShow="false" fxShow.gt-sm>{{row?.PersonalNumber}}</mat-cell>
              </ng-container>
              <ng-container matColumnDef="email">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxShow="false" fxShow.gt-sm>E-postadress</mat-header-cell>
                <mat-cell *matCellDef="let row" fxShow="false" fxShow.gt-sm>{{row?.Email}}</mat-cell>
              </ng-container>
              <ng-container matColumnDef="created">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxShow="false" fxShow.gt-sm>Medlem sedan</mat-header-cell>
                <mat-cell *matCellDef="let row" fxShow="false" fxShow.gt-sm>
                  {{(row?.Created == '0001-01-01T00:00:00' ? '' : row?.Created) | swedishDate: 'yyyy-MM-dd'}}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="lastLogin">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxShow="false" fxShow.gt-sm>Senast inloggad</mat-header-cell>
                <mat-cell *matCellDef="let row" fxShow="false" fxShow.gt-sm>
                  {{(row?.LastLogin == '2017-01-01T00:00:00' ? '' : row?.LastLogin) | swedishDate: 'yyyy-MM-dd'}}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="suspended">
                <mat-header-cell *matHeaderCellDef>Spärrat</mat-header-cell>
                <mat-cell *matCellDef="let row"><mat-icon *ngIf="row?.Suspended" aria-label="Spärrad">lock</mat-icon></mat-cell>
              </ng-container>
              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table>
            <div *ngIf="!usersLoading && !usersLoadError && dataSource?.filteredData?.length === 0" class="empty-state">Inga administratörer hittades.</div>
          </div>
        </div>

        <section class="role-description" aria-labelledby="role-description-title">
          <h2 id="role-description-title">Rollbeskrivning</h2>
          <p><strong>Master:</strong> Samma som nedan och dessutom redigera företagets uppgifter samt radera andra administratörers utkast.</p>
          <p><strong>Companyadmin:</strong> Har rättighet att skapa och redigera fakturor, lägga till kunder och lägga till nya administratörer.</p>
        </section>
      </div>
    </mat-tab>

    <mat-tab label="Medarbetare ({{paymentRecievers?.length || 0}})">
      <div class="tab-content">
        <div class="filter-bar">
          <mat-form-field class="search-field" appearance="fill" floatLabel="always" subscriptSizing="dynamic">
            <mat-label>Sök medarbetare</mat-label>
            <mat-icon matPrefix aria-hidden="true">search</mat-icon>
            <input [disabled]="receiversLoading || receiversLoadError" matInput #employeeSearch type="search" (input)="applyFilter2(employeeSearch.value)">
            <button *ngIf="employeeSearch.value" mat-icon-button matSuffix type="button"
                    (click)="employeeSearch.value = ''; applyFilter2(''); employeeSearch.focus()"
                    aria-label="Rensa sökning" matTooltip="Rensa sökning">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <div class="table-shell">
          <div class="table-scroll">
            <div *ngIf="receiversLoading" class="table-skeleton" role="status" aria-label="Laddar medarbetare">
              <div class="skeleton-row" *ngFor="let row of [1,2,3,4,5]" aria-hidden="true">
                <div *ngFor="let column of displayedColumns2" class="skeleton-column" [ngClass]="'mat-column-' + column">
                  <span class="skeleton-cell"></span>
                </div>
              </div>
            </div>
            <div *ngIf="!receiversLoading && receiversLoadError" class="empty-state" role="alert">Kunde inte läsa medarbetare. Försök öppna dialogen igen.</div>
            <mat-table [class.table-loading]="receiversLoading || receiversLoadError" [dataSource]="dataSource2" matSort (matSortChange)="sortData2($event)"
                       matSortActive="name" matSortDirection="asc" matSortDisableClear>
              <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Namn</mat-header-cell>
                <mat-cell *matCellDef="let row" (click)="editPaymentReciever(row)" class="clickable-cell">
                  <strong>{{row?.LastName + ', ' + row?.FirstName | truncate:30}}</strong>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="personalNumber">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Personnummer</mat-header-cell>
                <mat-cell *matCellDef="let row">{{row?.PersonalNumber}}</mat-cell>
              </ng-container>
              <ng-container matColumnDef="email">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxShow="false" fxShow.gt-sm>E-postadress</mat-header-cell>
                <mat-cell *matCellDef="let row" fxShow="false" fxShow.gt-sm>{{row?.Email | truncate:30}}</mat-cell>
              </ng-container>
              <ng-container matColumnDef="edit">
                <mat-header-cell *matHeaderCellDef fxShow="false" fxShow.gt-sm aria-label="Åtgärder"></mat-header-cell>
                <mat-cell *matCellDef="let row" fxShow="false" fxShow.gt-sm class="row-actions">
                  <button mat-icon-button type="button" (click)="editPaymentReciever(row)"
                          aria-label="Redigera medarbetare" matTooltip="Redigera">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button mat-icon-button type="button" class="delete-action" (click)="deletePaymentReciever(row)"
                          aria-label="Radera medarbetare" matTooltip="Radera">
                    <mat-icon>delete</mat-icon>
                  </button>
                </mat-cell>
              </ng-container>
              <mat-header-row *matHeaderRowDef="displayedColumns2"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns2;"></mat-row>
            </mat-table>
            <div *ngIf="!receiversLoading && !receiversLoadError && dataSource2?.filteredData?.length === 0" class="empty-state">Inga medarbetare hittades.</div>
          </div>
          <mat-paginator [disabled]="receiversLoading || receiversLoadError" #paginator2 [pageSizeOptions]="[5,10,25,100]"></mat-paginator>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</section>
